export default __webpack_public_path__ + "static/media/CriqueGrotesk-Medium.9ae2fb3a.woff2";